export default {
  'h_one': '链浏览器',
  'tit_one': '区块查询',
  'tit_two': '藏品查询',
  'HyperchainSpaceHeight': '超块高度',
  'SpaceHeight':'超块高度',
  'Nodes': '节点数',
  'NodeMap': '节点地图',
  'Blockchains': '子链数',
  'Concurrency': '并发峰值',
  'HBlock': '超块号',
  'LChains': '子链数',
  'Search': '搜索',
  'Tips': '示例：输入“11633”搜索超块； “11633,2”搜索子链； “11633,2,5”搜索子链区块。',
  'Time': '时间戳',
  'Blocks': '区块数',
  'Chains': '区块链数',
  'Next': '后一个',
  'Previous': '前一个',
  'HyperBlock': '超块号',
  'LocalBlockId': '子块号',
  'Localchains': '子链数',
  'BlockSize': '块大小',
  'BlockVersion': '块版本',
  'BlockHash': '块哈希',
  'PreviousBlockHash': '前驱区块哈希',
  'Consensus': '共识算法',
  'Difficulty': '难度',
  'Height': '高度',
  'Size': '块大小',
  'Ver': '版本',
  'Payload': '区块负载',
  'Localchain': '子链号',
  'LocalBlock': '子链区块号',
  'PreviousLocalBlock': '前驱区块号',
  'PreviousLocalBlockHash': '前驱区块哈希',
  'HyperblockHash': '超块哈希',
  'RAW': '区块负载原始格式',
  'PayloadHash': '负载哈希',
  'PayloadSize': '负载大小',
  'More': '更多',
  'Fewer': '收起',
  'Help': '帮助',
  'HyperBlockList': '超块列表',
  'LocalChainList': '子链列表',
  'LocalBlockList': '子链区块列表',
  'LocalchainType': '链类型',
  'DApp': '分布式应用',
  'HyperBlockMsg': '超块信息',
  'LocalChainMsg': '子链信息',
  'LocalBlockMsg': '子链区块信息',
  'Top': '回到顶部',
  'mainnet_default': '暂未开放，敬请期待',
  'PreviousHyperBlock_hash': '前驱超块哈希',
  'tx':'交易信息',
  'AppType': '应用类型',
  'T_token': '通证',
  'T_coin': '货币',
  'T_default': '通用',
  'Apps':'应用数',
  'AppName':'应用名称',
  'PayloadRaw': 'Payload原始数据',
  'PayloadParsed': 'Payload解析后的数据',
  'P_default': '无法识别的数据格式，需要数据解析器',
  'NFT_key1': '累计用户数量',
  'NFT_key2': '日均交易数量',
  'NFT_key3': '铸造藏品',
  'NFT_placeholder': '输入藏品编号/藏品哈希/交易哈希',

  node_map: {
    sidebarTitle: '节点状态',
    MoreBtnText: '更多',

    OffLine: '离线',
    Synchronizing: '正在同步数据',
    Idle: '空闲',
    LocalConsensus: '正在局部共识',
    GlobalConsensus: '正在全局共识',
    Success: '上链成功',
    Exception: '节点异常',
    Suspect: '有恶意节点嫌疑',

    HyperblockHight: '超块高度',
    NodesNum: '节点数',
    Peak: '今日交易峰值',
    TPS: '每秒交易数',
    NextHyperblock: '超块倒计时',

    NewNodeNumText: '新节点：',
  }
}